<template>
  <div
    v-if="tank">
    <material-card
      v-bind="{ title: getTitle(), text: getText() }"
      color="dover-blue"
      icon="mdi-account-convert">
      <v-layout
        wrap>
        <template
          v-if="!Maglink.isResponsive">
          <v-flex
            xs12
            md3
            lg3
            text-xs-center>
            <span
              class="dover-blue-color">
              {{ $t('Last measure: {0}', [currentDate]).toUpperCase() }}
            </span>
          </v-flex>
          <v-flex
            xs12
            md3
            lg3
            text-xs-center>
            <span
              class="dover-blue-color">
              {{ $t('Status: {0}', [status]).toUpperCase() }}
            </span>
          </v-flex>
          <v-flex
            xs12
            md2
            lg2
            text-xs-center>
            <v-btn
              v-if="tank.lastAlarm.ackStatus === 1"
              depressed
              small
              color="primary"
              @click="ackTankStatus">
              {{ $t('Ack is required') }}
            </v-btn>
            <span
              v-else
              class="dover-blue-color">
              {{ ackStatus }}
            </span>
          </v-flex>
          <v-flex
            xs12
            md2
            lg2
            text-xs-center>
            <v-btn
              v-show="belongsToGroup"
              depressed
              small
              color="dover-blue"
              @click="goToGroup()">
              {{ $t('Go to group') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md2
            lg2
            text-xs-center>
            <v-btn
              v-show="isDMPProbe"
              depressed
              small
              color="dover-blue"
              @click="openDiagnostic()">
              {{ $t('Diagnostic') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12
            text-xs-center>
            <hr>
          </v-flex>
        </template>
        <template
          v-else>
          <v-flex
            xs12
            md3
            lg3
            text-xs-center>
            <span
              class="dover-blue-color">
              {{ $t('Last measure: {0}', [currentDate]).toUpperCase() }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md3
            lg3
            text-xs-center>
            <span
              class="dover-blue-color">
              {{ $t('Status: {0}', [status]).toUpperCase() }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md2
            lg2
            text-xs-center>
            <v-btn
              v-if="tank.lastAlarm.ackStatus === 1"
              depressed
              small
              color="primary"
              @click="ackTankStatus">
              {{ $t('Ack is required') }}
            </v-btn>
            <span
              v-else
              class="dover-blue-color">
              {{ ackStatus }}
            </span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md2
            lg2
            text-xs-center>
            <v-btn
              v-show="belongsToGroup"
              depressed
              small
              color="dover-blue"
              @click="goToGroup()">
              {{ $t('Go to group') }}
            </v-btn>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md2
            lg2
            text-xs-center>
            <v-btn
              v-show="isDMPProbe"
              depressed
              small
              color="dover-blue"
              @click="openDiagnostic()">
              {{ $t('Diagnostic') }}
            </v-btn>
          </v-flex>
        </template>
        <v-dialog
          v-model="diagnosticDialog"
          persistent
          width="600px">
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title>
              {{ $t('Diagnostic') }}
            </v-card-title>

            <v-card-text class="px-0 py-0">
              <v-container>
                <v-layout
                  wrap>
                  <v-flex
                    v-if="progressBar.loading"
                    xs12
                    md12
                    lg12>
                    <span>{{ progressBar.label }}</span>
                    <MaglinkComponentLoadingBar
                      :loading="progressBar.loading"
                      :indeterminate="false"
                      :max-value="progressBar.maxValue"
                      :value="progressBar.currentValue" />
                  </v-flex>
                  <v-flex
                    xs12
                    md12
                    lg12>
                    <v-tabs
                      fixed-tabs
                      color="dover-blue"
                      slider-color="yellow"
                      dark >
                      <v-tab
                        :key="0"
                        ripple>
                        {{ $t('Quality [i]') }}
                      </v-tab>
                      <v-tab-item
                        :key="0">
                        <template>
                          <v-data-table
                            :headers="headers"
                            :items="iResponses"
                            :no-data-text="`${ Maglink.NoDataMessage(false) }`"
                            :no-results-text="`${ Maglink.NoDataMessage(true) }`">
                            <template
                              slot="items"
                              slot-scope="{ item }">
                              <tr
                                :style="{backgroundColor: backColor(item) }"
                                class= "text-xs-left">
                                <td >
                                  <v-icon
                                    v-if="item.delta < 900"
                                    color="error">mdi-alert</v-icon>
                                  <v-icon
                                    v-else-if="item.delta < 1000"
                                    color="warning">mdi-alert-octagon</v-icon>
                                  <v-icon
                                    v-else
                                    color="success">mdi-check-circle</v-icon>
                                </td>
                                <td class="text-xs-right">{{ item.rise }}</td>
                                <td class="text-xs-right">{{ item.fall }}</td>
                                <td class="text-xs-right">{{ item.delta }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </template>
                      </v-tab-item>
                    </v-tabs>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
              <v-flex
                xs6
                md6 />
              <v-flex
                xs3
                md3
                text-xs-right>
                <v-btn
                  color="secondary"
                  flat
                  @click="readDiagnostic()">
                  {{ $t('Read diagnostic') }}
                </v-btn>
              </v-flex>
              <v-flex
                xs3
                md3
                text-xs-right>
                <v-btn
                  color="secondary"
                  flat
                  @click="closeDiagnostic()">
                  {{ $t('Close') }}
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-flex
          xs12
          md7
          lg7
          text-xs-center>
          <img
            :src="imageUrl"
            width="70%"
            @click="goToGroup()" >
        </v-flex>
        <v-flex
          xs12
          md5
          lg5
          text-xs-center>
          <apexchart
            :options="lineChart.options"
            :series="lineChart.series"
            :height= "getGraphHeight"
            width= "100%"
            type= "line" />
        </v-flex>
        <v-flex
          :md4="tank.autoCalibrationEnabled"
          :md6="!tank.autoCalibrationEnabled"
          :lg4="tank.autoCalibrationEnabled"
          :lg6="!tank.autoCalibrationEnabled"
          xs12
          text-xs-center>
          <v-expansion-panel>
            <v-expansion-panel-content
              key="1"
              :class="deliveryClass">
              <template
                v-slot:header>
                <div>
                  {{ $t('Delivery') + ': ' + $t(tank.delivery.state) }}
                </div>
              </template>
              <v-card>
                <v-card-text>
                  <tr
                    v-for="(item, index) in deliveryLabels"
                    :key="index"
                    width="100%">
                    <td
                      width="50%"
                      class="text-xs-left">
                      {{ item }}:
                    </td>
                    <td
                      width="30%"
                      class="text-xs-right">
                      <b>{{ displayDelivery(index) }}</b>
                    </td>
                    <td
                      width="20%"
                      class="text-xs-left"
                      style="padding-left: 10px">
                      <b>{{ displayDeliveryUdm(index) }}</b>
                    </td>
                  </tr>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <v-flex
          :md4="tank.autoCalibrationEnabled"
          :md6="!tank.autoCalibrationEnabled"
          :lg4="tank.autoCalibrationEnabled"
          :lg6="!tank.autoCalibrationEnabled"
          xs12
          text-xs-center>
          <v-expansion-panel
            v-show="tank.leakage">
            <v-expansion-panel-content
              key="2"
              :class="leakageClass">
              <template v-slot:header>
                <div>{{ $t('Leak test') + ': ' + $t(tank.leakage.state) }}</div>
              </template>
              <v-card>
                <v-card-text>
                  <tr
                    v-for="(item, index) in leakLabels"
                    :key="index"
                    width="100%">
                    <td
                      width="50%"
                      class="text-xs-left">
                      {{ item }}:
                    </td>
                    <td
                      width="30%"
                      class="text-xs-right">
                      <b>{{ displayLeakage(index) }}</b>
                    </td>
                    <td
                      width="20%"
                      class="text-xs-left"
                      style="padding-left: 10px">
                      <b>{{ displayLeakageUdm(index) }}</b>
                    </td>
                  </tr>
                  <hr
                    v-if="Maglink.IsAdminUser()">
                  <v-menu
                    v-if="Maglink.IsAdminUser()"
                    offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-if="isEPAProbe"
                        color="secondary"
                        flat
                        dark
                        small
                        v-on="on">
                        {{ $t('Start') }}
                      </v-btn>
                      <v-btn
                        color="secondary"
                        flat
                        dark
                        small
                        @click="leakageEvent(1)">
                        {{ $t('Stop') }}
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-tile
                        v-for="(item, index) in leakThresholds"
                        :key="index"
                        content-class="dover-blue"
                        @click="leakageEvent(0, item.code)">
                        <v-list-tile-title>{{ item.desc }}</v-list-tile-title>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <v-flex
          v-if="tank.autoCalibrationEnabled"
          xs12
          md4
          lg4
          text-xs-center>
          <v-expansion-panel>
            <v-expansion-panel-content
              key="3"
              :class="calibrationClass">
              <template
                v-slot:header>
                <div>
                  {{ $t('Autocalibration') + ': ' + displayCalibration(5) }}
                </div>
              </template>
              <v-card>
                <v-card-text>
                  <tr
                    v-for="(item, index) in calibrationLabels"
                    :key="index"
                    width="100%">
                    <td
                      width="50%"
                      class="text-xs-left">
                      {{ item }}:
                    </td>
                    <td
                      width="50%"
                      class="text-xs-right">
                      <b>{{ displayCalibration(index) }}</b>
                    </td>
                  </tr>
                  <hr
                    v-if="Maglink.IsAdminUser()">
                  <v-menu
                    v-if="Maglink.IsAdminUser()"
                    offset-y>
                    <template v-slot:activator="{ }">
                      <v-btn
                        color="secondary"
                        flat
                        dark
                        small
                        @click="calibrationEvent(0)">
                        {{ $t('Start') }}
                      </v-btn>
                      <v-btn
                        color="secondary"
                        flat
                        dark
                        small
                        @click="calibrationEvent(1)">
                        {{ $t('Stop') }}
                      </v-btn>
                    </template>
                  </v-menu>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <material-stats-card
            v-bind="{ title: `${ volumeUnit }`, value: getCurrentValue(Maglink.VolumeToDisplay(tank.lastMeasurement.productVolume, systemSettings.volumeUnit)) }"
            :sub-text="`${ $t('Volume') }`"
            color="dover-blue"
            icon="mdi-chart-gantt"/>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <material-stats-card
            v-bind="{ title: `${ volumeUnit }`, value: getCurrentValue(Maglink.VolumeToDisplay(tank.lastMeasurement.productVolumeComp, systemSettings.volumeUnit)) }"
            :sub-text="`${ $t('TC volume') }`"
            color="dover-blue"
            icon="mdi-chart-gantt"/>
        </v-flex>
        <v-flex
          xs6
          md2
          lg2>
          <material-stats-card
            v-bind="{ title: `${ volumeUnit }`, value: getCurrentValue(Maglink.VolumeToDisplay(tank.lastMeasurement.ullage, systemSettings.volumeUnit)) }"
            :sub-text="`${ $t('Ullage') }`"
            color="dover-blue"
            icon="mdi-format-vertical-align-top"/>
        </v-flex>
        <v-flex
          xs6
          md2
          lg2>
          <material-stats-card
            v-bind="{ title: `${ volumeUnit }`, value: waterAefVolume() }"
            :sub-text="`${ $t('Water volume') }`"
            color="dover-blue"
            icon="mdi-water"/>
        </v-flex>
        <v-flex
          xs6
          md2
          lg2>
          <material-stats-card
            v-bind="{ title: `${ temperatureUnit }`, value: getCurrentValue(Maglink.TemperatureFormat(Maglink.TemperatureToDisplay(tank.lastMeasurement.temperature, systemSettings.temperatureUnit))) }"
            :sub-text="`${ $t('Temperature') }`"
            color="dover-blue"
            icon="mdi-oil-temperature"/>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <material-stats-card
            v-bind="{ value: getCurrentValue(Maglink.RoundFormat(tank.lastMeasurement.weight, 2)) }"
            :title="`${ $t('Kg') }`"
            :sub-text="`${ $t('Weight') }`"
            color="dover-blue"
            icon="mdi-weight-kilogram"/>
        </v-flex>
        <v-flex
          xs6
          md3
          lg3>
          <material-stats-card
            v-bind="{ value: densityValues }"
            :title="`${ 'API - ' + $t('kg/m3') }`"
            :sub-text="`${ $t('Density (TC density)') }`"
            color="dover-blue"
            icon="mdi-barrel"/>
        </v-flex>
        <v-flex
          xs6
          md2
          lg2>
          <material-stats-card
            v-bind="{ title: `${ levelUnit }`, value: getCurrentValue(Maglink.LevelToDisplay(tank.lastMeasurement.productLevel, systemSettings.levelUnit)) }"
            :sub-text="`${ $t('Level') }`"
            color="dover-blue"
            icon="mdi-elevation-decline"/>
        </v-flex>
        <v-flex
          xs6
          md2
          lg2>
          <material-stats-card
            v-bind="{ title: `${ levelUnit }`, value: waterAefLevel() }"
            :sub-text="`${ $t('Water level') }`"
            color="dover-blue"
            icon="mdi-water"/>
        </v-flex>
        <v-flex
          xs6
          md2
          lg2>
          <material-stats-card
            v-bind="{ title: '%', value: getCurrentValue(Maglink.RoundFormat(tank.workingCapacity, 0)) }"
            :sub-text="`${ $t('Safe working capacity') }`"
            color="dover-blue"
            icon="mdi-format-line-spacing"/>
        </v-flex>
      </v-layout>
    </material-card>
  </div>
</template>

<script>

import Vue from 'vue'
import { i18n } from '@/i18n'

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    lineChart: {
      series: [{
        name: '',
        data: []
      }],
      options: {
        chart: {
          background: '#ffffff',
          height: '450',
          width: '100%',
          type: 'line',
          stacked: false
        },
        noData: {//
          text: i18n.t('Loading...'),
          style: {
            fontSize: '26px'
          }
        },
        xaxis: {
          type: 'datetime'
        },
        tooltip: {
          x: {
            formatter: function (val) {
              let dt = new Date(val)
              return dt.toISOString().substr(11, 5)
            }
          }
        },
        title: {
          text: '',
          align: 'left'
        },
        yaxis: {
          title: {
            text: ''
          }
        }
      }
    },
    leakLabels: [],
    deliveryLabels: [],
    calibrationLabels: [],
    belongsToGroup: false,
    leakThresholds: [],
    graphConfig: [],
    levelUdm: '',
    volUdm: '',
    densityUdm: '',
    tempUdm: '',
    tickId: 0,
    autoTickId: 0,
    dataSelection: [0, 1],
    autoShowCounter: 0,
    dataSource: {
      data: [],
      day: ''
    },
    diagnosticDialog: false,
    headers: [
      { sortable: false, text: '' },
      { sortable: false, text: i18n.t('Rise'), align: 'center' },
      { sortable: false, text: i18n.t('Fall'), align: 'center' },
      { sortable: false, text: i18n.t('Delta'), align: 'center' }
    ],
    iResponses: [],
    iRequests: 0,

    commandQueue: [],
    commandIsActive: false,
    currentToken: undefined,
    currentCommand: undefined,
    mainTimerId: 0,
    responseTimerId: 0,
    progressBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0,
      tickId: 0,
      label: ''
    }
  }),
  computed: {
    isDMPProbe () {
      return this.Maglink.isDMPProbe(this.tank.probeType)
    },
    isEPAProbe () {
      return this.Maglink.isEPAProbe(this.tank.probeType)
    },
    getGraphHeight () {
      if (Vue.prototype.Maglink.isResponsive) {
        return '400px'
      } else {
        return '95%'
      }
    },
    densityValues () {
      return this.getCurrentValue(this.Maglink.DensityFormat(this.tank.lastMeasurement.density)) + ' (' + this.getCurrentValue(this.Maglink.DensityFormat(this.tank.lastMeasurement.densityComp)) + ')'
    },
    calibrationClass () {
      return 'dover-blue-color'
      /*
      if (this.tank.delivery.state === 'IDLE') return 'success'
      if (this.tank.delivery.state === 'ENDING') return 'error'
      return 'warning'
      */
    },
    deliveryClass () {
      return 'dover-blue-color'
      /*
      if (this.tank.delivery.state === 'IDLE') return 'success'
      if (this.tank.delivery.state === 'ENDING') return 'error'
      return 'warning'
      */
    },
    leakageClass () {
      return 'dover-blue-color'
      /*
      if (this.tank.leakage.state === 'IDLE') return 'success'
      return 'warning'
      */
    },
    status () {
      return this.Maglink.GetStatusInfo(this.tank.lastMeasurement.tankStatus).statusDesc
    },
    ackStatus () {
      if (this.tank.lastAlarm.ackStatus === 0) return this.$t('No alarm').toUpperCase()
      else if (this.tank.lastAlarm.ackStatus === 1) return this.$t('Alarm is active').toUpperCase()
      else if (this.tank.lastAlarm.ackStatus === 2) return this.$t('Alarm is acknowledged').toUpperCase()
    },
    levelUnit () {
      return this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    },
    volumeUnit () {
      return this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    },
    temperatureUnit () {
      return this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc
    },
    currentDate () {
      // return this.Maglink.GetCustomDateTime(this.tank.lastMeasurement.measuredOn, this.systemSettings.dateFormat)
      return this.getCurrentValue(this.Maglink.GetCustomDateTime(this.tank.lastMeasurement.measuredOn, this.systemSettings.dateFormat))
    },
    imageUrl () {
      // offline image
      let imagePath = './img/tank/tank-offline.svg'
      if (this.tank.lastMeasurement.tankStatus === 32) {
        return imagePath
      }

      imagePath = './img/tank/tank-empty{0}.svg'
      // get % value
      let percValue = this.tank.maxLevel === 0 ? 0 : Math.round((this.tank.lastMeasurement.productLevel * 100) / this.tank.maxLevel)
      percValue = Math.round(percValue / 10) * 10
      percValue = ('00' + percValue).slice(-3)
      let hasWater = (this.tank.lastMeasurement.waterLevel > 0) ? '-water' : ''

      // check empty tank
      if (percValue === '000') {
        imagePath = imagePath.replace('{0}', hasWater)

        return imagePath
      }

      let prodFamily = this.tank.productFamily
      imagePath = './img/tank/tank-{0}-{1}{2}.svg'
      imagePath = imagePath.replace('{0}', this.Maglink.TankColor[prodFamily]) // 0..12
      imagePath = imagePath.replace('{1}', percValue)
      imagePath = imagePath.replace('{2}', hasWater)

      return imagePath
    }
  },
  mounted () {
    this.leakLabels[0] = this.$t('Type')
    this.leakLabels[1] = this.$t('Started on')
    this.leakLabels[2] = this.$t('Initial level')
    this.leakLabels[3] = this.$t('Initial TC volume')
    this.leakLabels[4] = this.$t('Current time')
    this.leakLabels[5] = this.$t('Current level')
    this.leakLabels[6] = this.$t('Current TC volume')
    this.leakLabels[7] = this.$t('Leak rate')
    this.leakLabels[8] = this.$t('Duration') // this.leakLabels[8] = this.$t('Duration ({0})', [ this.$t('min') ])

    this.deliveryLabels[0] = this.$t('Started on')
    this.deliveryLabels[1] = this.$t('Initial level')
    this.deliveryLabels[2] = this.$t('Initial volume')
    this.deliveryLabels[3] = this.$t('Completed on')
    this.deliveryLabels[4] = this.$t('Final level')
    this.deliveryLabels[5] = this.$t('Final volume')
    this.deliveryLabels[6] = this.$t('Delivered volume')
    this.deliveryLabels[7] = this.$t('Duration')
    // this.deliveryLabels[7] = this.$t('Above counter')
    // this.deliveryLabels[8] = this.$t('Below counter')

    this.calibrationLabels[0] = this.$t('Number of segments')
    this.calibrationLabels[1] = this.$t('Low segment')
    this.calibrationLabels[2] = this.$t('High segment')
    this.calibrationLabels[3] = this.$t('Max cycles')
    this.calibrationLabels[4] = this.$t('Required cycles')
    this.calibrationLabels[5] = this.$t('Status')
    this.calibrationLabels[6] = this.$t('Completed segments')
    this.calibrationLabels[7] = this.$t('Completed') + ' %'

    this.leakThresholds = this.options.leakThresholds
    // remove 3.0 check
    this.leakThresholds.length = 2

    this.tickId = setInterval(this.getDataSource, 1000 * 60)
    this.autoTickId = setInterval(this.autoShow, 1000 * 10)

    this.levelUdm = this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
    this.densityUdm = 'API - ' + this.$t('kg/m3')
    this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc

    this.loadGraphConfig()
    this.getDataSource()

    this.belongsToGroup = (this.tank.tankGroup > 0)
  },
  beforeDestroy () {
    // Perform the teardown procedure for someLeakyProperty.
    clearInterval(this.tickId)
    clearInterval(this.autoTickId)
    this.clearTimers()
  },
  methods: {
    getCurrentValue (value) {
      // no link alarm
      if ((this.tank.lastMeasurement.tankStatus & 32) === 32) return '--'

      return value
    },
    displayCalibration (item) {
      let calibration = this.tank.calibration
      if (calibration === undefined) return

      if (item === 0) {
        return calibration.numberOfCalibrationSegments
      }
      if (item === 1) {
        return calibration.lowCalibrationSegment
      }
      if (item === 2) {
        return calibration.highCalibrationSegment
      }
      if (item === 3) {
        return calibration.maxCalibrationCycles
      }
      if (item === 4) {
        return calibration.requiredCalibrationCycles
      }
      if (item === 5) {
        return this.$t(calibration.state)
      }
      if (item === 6) {
        return calibration.numberOfCompletedSegments
      }
      if (item === 7) {
        return this.Maglink.RoundFormat(calibration.completedPercent, 1)
      }

      return item
    },
    displayDelivery (item) {
      let delivery = this.tank.delivery
      if (delivery.initialTime === 0 && delivery.finalTime === 0) return '--'

      if (item === 0) {
        return this.Maglink.GetCustomDateTime(delivery.initialTime, 'dd-mm-yyyy')
      }
      if (item === 1) {
        return this.Maglink.LevelToDisplay(delivery.initialProductLevel, this.systemSettings.levelUnit || 0)
      }
      if (item === 2) {
        return this.Maglink.VolumeToDisplay(delivery.initialProductVolume, this.systemSettings.volumeUnit || 0)
      }
      if (item === 3) {
        return this.Maglink.GetCustomDateTime(delivery.finalTime, 'dd-mm-yyyy')
      }
      if (item === 4) {
        return this.Maglink.LevelToDisplay(delivery.finalProductLevel, this.systemSettings.levelUnit || 0)
      }
      if (item === 5) {
        return this.Maglink.VolumeToDisplay(delivery.finalProductVolume, this.systemSettings.volumeUnit || 0)
      }
      if (item === 6) {
        return this.Maglink.VolumeToDisplay(delivery.finalDeliveredVolume, this.systemSettings.volumeUnit || 0)
      }
      if (item === 7) {
        return this.Maglink.GetHourMinuteSecondFormat(delivery.initialTime, delivery.finalTime)
      }
      /*
      if (item === 7) {
        return delivery.initialAboveCounter
      }
      if (item === 8) {
        return delivery.finalBelowCounter
      }
      */
    },
    displayLeakage (item) {
      let leak = this.tank.leakage
      if (leak === undefined) {
        return '--'
      }

      if (leak.initialTime === 0 && leak.prevTime === 0) return '--'

      if (item === 0) {
        if (!this.isEPAProbe) {
          return this.Maglink.LeakageToDisplay(this.tank.customTankLeakRate, this.systemSettings.volumeUnit || 0)
        }
        return leak.leakThreshold > 1 ? '---' : this.options.leakThresholds[leak.leakThreshold || 0].desc
      }
      if (item === 1) {
        return this.Maglink.GetCustomDateTime(leak.initialTime, 'dd-mm-yyyy')
      }
      if (item === 2) {
        return this.Maglink.LevelToDisplay(leak.initialProductLevel, this.systemSettings.levelUnit || 0)
      }
      if (item === 3) {
        return this.Maglink.VolumeToDisplay(leak.initialProductVolumeComp, this.systemSettings.volumeUnit || 0)
      }
      if (item === 4) {
        return this.Maglink.GetCustomDateTime(leak.prevTime, 'dd-mm-yyyy')
      }
      if (item === 5) {
        return this.Maglink.LevelToDisplay(leak.prevProductLevel, this.systemSettings.levelUnit || 0)
      }
      if (item === 6) {
        return this.Maglink.VolumeToDisplay(leak.prevProductVolumeComp, this.systemSettings.volumeUnit || 0)
      }
      if (item === 7) {
        if (leak.valid) {
          return this.Maglink.LeakageToDisplay(leak.hourlyLeakage, this.systemSettings.volumeUnit || 0)
        }
        return '--'
      }
      if (item === 8) {
        // let value = leak.prevTime - leak.initialTime
        // let min = this.Maglink.RoundFormat(Math.floor(value / 60), 0)
        // let sec = value % 60
        // return min + ':' + sec.toString()

        return this.Maglink.GetHourMinuteSecondFormat(leak.initialTime, leak.prevTime)
      }
    },
    displayLeakageUdm (item) {
      let leak = this.tank.leakage

      if (leak.initialTime === 0 && leak.prevTime === 0) return ''

      if (item === 2 || item === 5) {
        return this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
      }
      if (item === 3 || item === 6) {
        return this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
      }
      if (item === 7 || (item === 0 && !this.isEPAProbe)) {
        return this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc + '/' + this.$t('H').toLowerCase()
      }

      return ''
    },
    displayDeliveryUdm (item) {
      let delivery = this.tank.delivery
      if (delivery.initialTime === 0 && delivery.prevTime === 0) return ''

      if (item === 1 || item === 4) {
        return this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
      }
      if (item === 2 || item === 5 || item === 6) {
        return this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc
      }

      return ''
    },
    goToGroup () {
      if (!this.belongsToGroup) return

      clearInterval(this.tickId)
      clearInterval(this.autoTickId)

      this.$router.push('/tankgroupstatus?tankGroup=' + this.tank.tankGroup)
    },
    loadGraphConfig () {
      let volUnitIndex = this.systemSettings.volumeUnit
      let levelUnitIndex = this.systemSettings.levelUnit
      let tempUnitIndex = this.systemSettings.temperatureUnit

      this.graphConfig = [
        {
          index: 0,
          desc: this.$t('Volume'),
          key: 'productVolume',
          group: 'vol',
          yValue: [],
          yTooltipTitle: this.$t('Volume ({0})', [ this.volUdm ]),
          yTitle: this.volUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 1,
          desc: this.$t('TC Volume'),
          key: 'productVolumeComp',
          group: 'vol',
          yValue: [],
          yTooltipTitle: this.$t('TC Volume ({0})', [ this.volUdm ]),
          yTitle: this.volUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 2,
          desc: this.waterAefGraphDescVolume(),
          key: 'waterVolume',
          group: 'Wvol',
          yValue: [],
          yTooltipTitle: this.waterAefGraphToolTipTitleVolume(),
          yTitle: this.volUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.VolumeToDisplay(list[index], volUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 3,
          desc: this.$t('Temperature'),
          key: 'temperature',
          group: 'temp',
          yValue: [],
          yTooltipTitle: this.$t('Temperature ({0})', [ this.tempUdm ]),
          yTitle: this.tempUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.TemperatureFormat(Vue.prototype.Maglink.TemperatureToDisplay(list[index], tempUnitIndex)) * 1)
            }
            return res
          }
        },
        {
          index: 4,
          desc: this.$t('Product'),
          key: 'productLevel',
          group: 'level',
          yValue: [],
          yTooltipTitle: this.$t('Product ({0})', [ this.levelUdm ]),
          yTitle: this.levelUdm,
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.LevelToDisplay(list[index], levelUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 5,
          desc: this.waterAefGraphDescLevel(),
          key: this.waterAefGraphKey(),
          group: 'level',
          yValue: [],
          yTooltipTitle: this.waterAefGraphToolTipTitleLevel(),
          yTitle: this.waterAefGraphTitle(),
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.LevelToDisplay(list[index], levelUnitIndex) * 1)
            }
            return res
          }
        },
        {
          index: 6,
          desc: this.$t('Density'),
          key: 'density',
          group: 'den',
          yValue: [],
          yTooltipTitle: this.$t('Density') + ' (API - ' + this.$t('kg/m3') + ')',
          yTitle: 'API - ' + this.$t('kg/m3'),
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.DensityFormat(list[index]) * 1)
            }
            return res
          }
        },
        {
          index: 7,
          desc: this.$t('TC Density'),
          key: 'densityComp',
          group: 'den',
          yValue: [],
          yTooltipTitle: this.$t('TC Density') + ' (API - ' + this.$t('kg/m3') + ')',
          yTitle: 'API - ' + this.$t('kg/m3'),
          formatter: function (list) {
            let res = []
            for (let index = 0; index < list.length; index++) {
              res.push(Vue.prototype.Maglink.DensityFormat(list[index]) * 1)
            }
            return res
          }
        }
      ]

      // IMPORTANT TO FORCE REFRESH
      // this.dataSelectionKey += 1
    },
    getDataSource () {
      let dt = new Date()
      let day = this.Maglink.GetCustomDate(this.Maglink.GetLocalToUtcTime(dt.getTime()).date, 'yyyy-MM-dd')

      // RESULT IS ORDERED BY DATE DESC
      this.Maglink.GetReportHistory({ number: this.tank.tankNumber, fromDay: day })
        .then(response => {
          // put in cronological order
          this.dataSource.data = response.data.map(a => a).reverse()
          this.dataSource.day = day

          this.fillGraph()
        })
        .catch(error => {
          this.snack('error', error.message)
        })
    },
    autoShow () {
      this.autoShowCounter += 1
      if (this.autoShowCounter === 5) {
        this.autoShowCounter = 0
      }

      if (this.autoShowCounter === 1 && this.tank.probeWaterFloat !== 1) { // no water float
        this.autoShowCounter += 1
      }
      if (this.autoShowCounter === 4 && this.tank.probeDensmeter === 0) {
        this.autoShowCounter = 0
      }

      if (this.autoShowCounter === 0) {
        this.dataSelection = [0, 1] // volume, TC volume
      } else if (this.autoShowCounter === 1) {
        this.dataSelection = [2] // water Volume
      } else if (this.autoShowCounter === 2) {
        this.dataSelection = [3] // temperature
      } else if (this.autoShowCounter === 3) {
        if (this.tank.probeWaterFloat !== 1) { // no water float
          this.dataSelection = [4] // product
        } else {
          this.dataSelection = [4, 5] // product, water
        }
      } else if (this.autoShowCounter === 4) {
        this.dataSelection = [6, 7] // density, TC density
      }

      this.fillGraph()
    },
    fillGraph () {
      // x-axis
      let xValues = this.dataSource.data.map(a => a.measuredOn * 1000)

      for (let count = 0; count < xValues.length - 1; count++) {
        xValues[count] = this.Maglink.GetUtcToLocalTime(xValues[count]).number
      }

      let series = []
      let columnDesc = []
      let yTitle = ''

      // column selected
      let selection = this.dataSelection // this.dataSelection[this.dataSelectionIndex]
      for (let index = 0; index < selection.length; index++) {
        // current column index
        let itemIndex = selection[index]
        // current column config
        let currConfig = this.graphConfig[itemIndex]

        // it's the same for each comm element
        yTitle = currConfig.yTitle
        columnDesc.push(currConfig.desc)
        // get y values
        currConfig.yValue = currConfig.formatter(this.dataSource.data.map(a => a[currConfig.key]))

        // must combine x value with y values
        let yValue = []
        for (let count = 0; count < currConfig.yValue.length - 1; count++) {
          let item = []
          item.push(xValues[count])
          item.push(currConfig.yValue[count])
          yValue.push(item)
        }
        series.push({
          name: currConfig.yTooltipTitle,
          data: yValue
        })
      }

      let xLabel = this.$t('Time') + ': '
      let reportTitle = this.Maglink.GetCustomDate(new Date(this.dataSource.day), this.systemSettings.dateFormat)
      reportTitle += ' (' + columnDesc.join(',') + ')'

      this.lineChart = {
        series: series,
        options: {
          xaxis: {
            type: 'datetime',
            title: {
              text: ''
            }
          },
          tooltip: {
            x: {
              formatter: function (val) {
                let dt = new Date(val)
                return xLabel + dt.toISOString().substr(11, 5)
              }
            }
          },
          title: {
            text: reportTitle,
            align: 'left'
          },
          yaxis: {
            title: {
              text: yTitle
            }
          }
        }
      }
    },
    getText () {
      let result = this.$t('Height {0}', [this.Maglink.LevelToDisplay(this.tank.maxLevel, this.systemSettings.levelUnit)])
      result += ' ' + this.options.levelUnits[this.systemSettings.levelUnit || 0].desc + ' - '
      result += this.$t('Max volume {0}', [this.Maglink.VolumeToDisplay(this.tank.maxVolume, this.systemSettings.volumeUnit)])
      result += ' ' + this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

      return result
    },
    getTitle () {
      let result = this.tank.tankDescription
      if (result === undefined) {
        result = this.$t('Tank {0}', [this.tank.tankNumber])
      }
      if (this.tank.serial !== undefined && this.tank.serial.length > 0) {
        result += ' (' + this.$t('Serial: {0}', [this.tank.serial]) + ')'
      }

      return result
    },
    calibrationEvent (type) {
      // start
      if (type === 0) {
        this.Maglink.TankCalibrationStart(this.tank.tankNumber, 0)
          .then(response => {
            this.snack('success', this.$t('Tank calibration {0}', [ this.$t('Started').toUpperCase() ]))
          })
          .catch(error => {
            this.snack('error', error.message)
          })
      }
      // stop
      if (type === 1) {
        this.Maglink.TankCalibrationStop(this.tank.tankNumber)
          .then(response => {
            this.snack('success', this.$t('Tank calibration {0}', [ this.$t('Stopped').toUpperCase() ]))
          })
          .catch(error => {
            this.snack('error', error.message)
          })
      }
    },
    leakageEvent (type, code) {
      // start
      if (type === 0) {
        this.Maglink.TankLeakageStart(this.tank.tankNumber, code)
          .then(response => {
            this.snack('success', this.$t('Leak detection {0}', [ this.$t('Started').toUpperCase() ]))
          })
          .catch(error => {
            this.snack('error', error.message)
          })
      }
      // stop
      if (type === 1) {
        this.Maglink.TankLeakageStop(this.tank.tankNumber)
          .then(response => {
            this.snack('success', this.$t('Leak detection {0}', [ this.$t('Stopped').toUpperCase() ]))
          })
          .catch(error => {
            this.snack('error', error.message)
          })
      }
    },
    ackTankStatus () {
      this.$emit('ackTankStatus', this.tank.tankNumber)
    },
    addCommand_i_toQueue (tankNumber, serialNumber) {
      // read version
      this.addCommandToQueue('i', 'i' + this.Maglink.PadRight(serialNumber, 5) + '{CR}', this.$t('Pulse'), tankNumber, serialNumber)
    },
    addCommandToQueue (commandType, cmdString, cmdDescription, tankNumber, serialNumber) {
      this.commandQueue.push({ cmdType: commandType, cmdText: cmdString, cmdDesc: cmdDescription, tankNumber: tankNumber, serialNumber: serialNumber, processing: false })
    },

    backColor (item) {
      return ((item.seq % 2 === 0) ? '#cfdbfb' : 'transparent')
    },
    closeDiagnostic () {
      this.diagnosticDialog = false
    },
    openDiagnostic () {
      this.iResponses = []
      this.iRequests = 0
      this.diagnosticDialog = true
    },
    readDiagnostic () {
      if (this.isDMPProbe) { this.addCommand_i_toQueue(this.tank.number, this.tank.serial) }

      this.startMainTimer(200)
    },
    waterAefGraphDescLevel () {
      return this.$t('Water')
    },
    waterAefGraphDescVolume () {
      return this.$t('Water')
    },
    waterAefGraphKey () {
      return 'waterLevel'
    },
    waterAefGraphTitle () {
      return this.levelUdm
    },
    waterAefGraphToolTipTitleLevel () {
      return this.$t('Water ({0})', [ this.levelUdm ])
    },
    waterAefGraphToolTipTitleVolume () {
      return this.$t('Water ({0})', [ this.volUdm ])
    },
    waterAefLevel () {
      if (this.tank.probeWaterFloat !== 1) { // not a water float
        if (this.isAEFWaterAlarm()) {
          return this.$t('WATER') + ' ' + this.$t('alarm')
        }
        if (this.isAEFEthanolAlarm()) {
          return this.$t('ETHANOL') + ' ' + this.$t('warning')
        }
        return '-'
      } else {
        return this.getCurrentValue(this.Maglink.LevelToDisplay(this.tank.lastMeasurement.waterLevel, this.systemSettings.levelUnit))
      }
    },
    waterAefVolume () {
      if (this.tank.probeWaterFloat !== 1) { // not a water float
        return '-'
      } else {
        return this.getCurrentValue(this.Maglink.VolumeToDisplay(this.tank.lastMeasurement.waterVolume, this.systemSettings.volumeUnit))
      }
    },
    isAEFWaterAlarm () {
      return ((this.tank.lastMeasurement.tankStatus & 1) === 1)
    },
    isAEFEthanolAlarm () {
      return ((this.tank.lastMeasurement.tankStatus & (2 * 1024)) === (2 * 1024))
    },
    clearTimers () {
      // just to be sure
      this.commandIsActive = false

      this.stopMainTimer()
      this.stopProgressBarTimer()
    },
    stopProgressBarTimer () {
      clearInterval(this.progressBar.tickId)
      this.progressBar.tickId = 0
      this.progressBar.loading = false
      this.progressBar.currentValue = 0
      this.progressBar.label = ''
    },
    startProgressBarTimer () {
      // manage progressbar to show user to wait
      if (this.progressBar.tickId === 0) {
        this.progressBar.label = this.$t('Awaiting for probe response...')
        this.progressBar.loading = true
        this.progressBar.currentValue = 0
        this.progressBar.tickId = setInterval(this.progressBarTick, 100)
      }
    },
    progressBarTick () {
      if (this.progressBar.currentValue >= this.progressBar.maxValue) this.progressBar.currentValue = 0
      this.progressBar.currentValue += 1
      this.progressBar.label = this.$t('Awaiting for probe response \'{0}\' command', [ this.currentCommand.cmdDesc ])
    },
    startMainTimer (msecs) {
      if (msecs === undefined) {
        msecs = 5000
      }

      this.mainTimerId = setTimeout(this.sendCommandTimerTick, msecs)
    },
    stopMainTimer () {
      clearInterval(this.mainTimerId)
      this.mainTimerId = 0
    },
    startResponseTimer (msecs) {
      this.responseTimerId = setTimeout(this.sendResponseCommandTimerTick, msecs)
    },
    sendCommandTimerTick () {
      // no command to process
      if (this.commandQueue.length === 0) {
        this.stopProgressBarTimer()
        return
      }

      this.startProgressBarTimer()

      // current command
      this.currentCommand = this.commandQueue[0]

      // CREATING COMMAND TO SEND
      this.currentToken = this.Maglink.GetToken(this.currentCommand.serialNumber, this.currentCommand.tankNumber, this.currentCommand.cmdType, this.currentCommand.cmdText)

      // SENDING QUESTION COMMAND NOW
      this.Maglink.SendProbeCommand(this.currentToken.command.serial, this.currentToken.command.text)
        .then(response => {
          // get token
          this.currentToken.response.id = response.data.token

          // delete because processed
          this.commandQueue.shift()

          this.currentToken.retry = 0
          this.startResponseTimer(2000)
        })
        .catch(error => {
          this.commandQueue.shift()

          this.currentToken.failCounter += 1
          this.currentToken.response.errorCode = 1000
          this.currentToken.response.errorMsg = error.message

          this.snack('error', this.currentToken.command.type + ' --> ' + error.message)
          this.startMainTimer(1000)
        })
    },
    sendResponseCommandTimerTick () {
      // no command to process
      if (this.currentToken === undefined) {
        return
      }

      // read response
      this.Maglink.GetProbeResponse(this.currentToken.command.serial, this.currentToken.response.id)
        .then(response => {
          this.currentToken.response.text = response.data.response
          this.currentToken.response.status = response.data.completed

          // command has been processed successfully
          if (this.currentToken.response.status) {
            if (this.currentToken.response.text.length < 1 || this.currentToken.response.text === ' ') {
              // this.snack('error', this.$t('no probe response'))
            }
            this.decodeProbeResponse(this.currentToken)
            if (this.currentToken.response.errorCode !== 0) {
              this.snack('error', this.currentToken.command.text + ' --> ' + this.currentToken.response.errorMsg)
            }
            this.startMainTimer(200)
          } else {
            this.currentToken.retry += 1
            if (this.currentToken.retry > 15) {
              this.startMainTimer(200)
              // this.snack('error', this.$t('no probe response'))
            } else {
              this.startResponseTimer(2000)
            }
          }
        })
        .catch(error => {
          this.currentToken.failCounter += 1
          this.currentToken.response.errorCode = 1000
          this.currentToken.response.errorMsg = error.message
          this.snack('error', this.currentToken.command.text + ' --> ' + error.message + ' (' + this.currentToken.failCounter + ')')
          this.startMainTimer(1000)
        })
    },
    decodeProbeResponse (token) {
      // response structure is based upon the command type
      token = this.Maglink.DecodeProbeResponse(token)
      // check for errors
      if (token.response.errorCode !== 0) return

      if (token.command.type === 'i') {
        this.updatePulseDiagnostic(token.command.serial, token.response.values.data)
      }
    },

    updatePulseDiagnostic (serialNumber, pulses) {
      if (serialNumber === undefined || serialNumber.length < 1) {
        return
      }
      this.iRequests++
      for (var i = pulses.length - 1; i >= 0; i--) {
        pulses[i].seq = this.iRequests
        this.iResponses.unshift(pulses[i])
      }
    },

    snack (color, message) {
      // TO MANAGE MOVING FROM PAGE QUIKER THAN 5 SECS
      if (message.indexOf('_t') !== -1) return

      message = i18n.t('Tank status detail') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
